import { css } from "@vitality-ds/system";
export default css({
  display: "inline-flex",
  alignItems: "center",
  gap: "$sm",
  lineHeight: "$caption"
});